/**
 * Security utilities to mitigate CWE-601 (Open Redirect) and input vulnerabilities.
 */

/**
 * Validates and sanitizes internal application redirect paths.
 * Enforces that paths strictly start with a single forward slash ('/'),
 * blocking protocol-relative URLs ('//'), backslash escapes ('/\\', '\\'),
 * and pseudo-protocols ('javascript:', 'data:').
 */
export const sanitizeRedirectPath = (path: unknown): string => {
  if (typeof path !== 'string') {
    return '/';
  }

  const trimmed = path.trim();

  if (
    !trimmed.startsWith('/') ||
    trimmed.startsWith('//') ||
    trimmed.startsWith('/\\') ||
    trimmed.includes('\\') ||
    trimmed.toLowerCase().startsWith('/javascript:') ||
    trimmed.toLowerCase().startsWith('/data:') ||
    trimmed.includes('\0')
  ) {
    return '/';
  }

  return trimmed;
};
